import React, { Component } from 'react';
import {
  Navbar,
  Nav,
  NavbarToggler,
  NavItem,
  NavLink,
  Container,
  Collapse,
} from 'reactstrap';
import { Link } from 'react-router-dom';
import Logo from '../../assets/images/Logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

import ScrollspyNav from './Scrollspy';

class NavbarPage extends Component {
  // render() {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMenu: false,
    };
    this.toggleNavbar = this.toggleNavbar.bind(this);
  }

  toggleNavbar() {
    this.setState({ isOpenMenu: !this.state.isOpenMenu });
  }

  render() {
    let targetId = this.props.navItems.map((item) => {
      return item.idnm;
    });
    return (
      <React.Fragment>
        <Navbar
          expand='lg'
          className=' fixed-top navbar-custom sticky sticky-dark align-items-center'
          id='navbar'
        >
          <Container>
            {/* LOGO */}
            <Link className='logo mr-3' to='/'>
              <img src={Logo} alt='' />
              {/* {this.props.imglight === true ? (
                <img src={logolight} alt="" height="26" />
              ) : (
                <img src={logodark} alt="" height="26" />
              )} */}
            </Link>
            <NavbarToggler className='me-2' onClick={this.toggleNavbar}>
              <FontAwesomeIcon icon={faBars} />
            </NavbarToggler>
            <Collapse
              id='navbarCollapse'
              isOpen={this.state.isOpenMenu}
              className='navbar-collapse'
            >
              {/* <ScrollspyNav
                scrollTargetIds={targetId}
                scrollDuration="800"
                headerBackground="true"
                activeNavClass="active"
                className="navbar-collapse"
              > */}
              <Nav className='navbar-nav ml-auto' id='navbar-navlist'>
                {this.props.navItems.map((item, key) => (
                  <NavItem
                    key={key}
                    className={
                      item.active === true
                        ? 'active'
                        : '' || item.box === true
                        ? 'nav-register'
                        : ''
                    }
                  >
                    <NavLink
                      className={item.active === true ? 'active' : ''}
                      href={item.idnm}
                    >
                      {item.navheading}
                    </NavLink>
                  </NavItem>
                ))}
              </Nav>
              {/* </ScrollspyNav> */}
            </Collapse>
          </Container>
        </Navbar>
      </React.Fragment>
    );
  }
}
// }
export default NavbarPage;
